import useChatMessage from '@views/chat/components/middle-column/useChatMessage';
import {useEffect, useMemo, useState} from 'react';
import {ICommentModel} from '@src/@interfaces/models/Comment/ICommentModel';
import app from '@src/helpers/app';

export default function useComment(commentId: string | number | undefined | null) {
    const message = useChatMessage(commentId);
    const [isLoading, setIsLoading] = useState(message == null);
    const [wasRequested, setWasRequested] = useState(false);
    const [error, setError] = useState<Error | null>(null);
    const [comment, setComment] = useState<ICommentModel | null>(message);

    useEffect(() => {
        if (!comment && message) {
            setComment(message);
            setIsLoading(false);
        }
    }, [comment, commentId, message]);

    useEffect(() => {
        if (comment || wasRequested || !commentId) {
            return;
        }

        setIsLoading(true);

        const subscription = app('comments').getById(String(commentId));

        subscription.then(comment => {
            setComment(comment);
        }).catch(error => {
            setError(error);
        }).finally(() => {
            setWasRequested(true);
            setIsLoading(false);
        });

        return () => subscription.cancel();
    }, [comment, commentId, isLoading, wasRequested]);

    return useMemo(() => {
        return {comment, error, isLoading};
    }, [comment, error, isLoading]);
}
